import React from 'react';
import { Button } from 'antd';

const EditBoxModal = ({ isVisible, onOk, onCancel, updating, children, title = "Izmena podataka" }) => {
  if (!isVisible) return null;

  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal-container">
        {/* Header */}
        <div className="custom-modal-header">
          <span className="custom-modal-title">{title}</span>
          <span className="custom-modal-close" onClick={onCancel}>&times;</span>
        </div>

        {/* Body */}
        <div className="custom-modal-body">
          {children}
        </div>

        {/* Footer */}
        <div className="custom-modal-footer">
          <Button 
            onClick={onCancel} 
            className="custom-btn-cancel"
          >
            Odustani
          </Button>
          <Button 
            type="primary" 
            onClick={onOk} 
            loading={updating}
            className="custom-btn-save"
          >
            Sačuvaj
          </Button>
        </div>
      </div>

      <style>{`
        /* Pozadina koja zamućuje ekran */
        .custom-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.7);
          backdrop-filter: blur(4px);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }

        /* Glavni kontejner - SAMO PLAVI NEON, BEZ BELOG */
        .custom-modal-container {
          background-color: #1e293b;
          width: 500px;
          border-radius: 8px;
          border: 1px solid #334155;
          box-shadow: 0 0 25px 5px rgba(34, 211, 238, 0.4);
          overflow: hidden;
          animation: modalAppear 0.3s ease-out;
        }

        .custom-modal-header {
          padding: 16px 24px;
          border-bottom: 1px solid #334155;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .custom-modal-title {
          color: white;
          font-size: 16px;
          font-weight: 600;
        }

        .custom-modal-close {
          color: #94a3b8;
          font-size: 24px;
          cursor: pointer;
          line-height: 1;
        }

        .custom-modal-body {
          padding: 24px;
        }

        .custom-modal-footer {
          padding: 16px 24px;
          border-top: 1px solid #334155;
          display: flex;
          justify-content: flex-end;
          gap: 12px;
        }

        /* Dugmad */
        .custom-btn-cancel {
          background: #334155 !important;
          color: white !important;
          border: none !important;
        }

        .custom-btn-save {
          background: #3b82f6 !important;
          border: none !important;
          box-shadow: 0 0 10px rgba(59, 130, 246, 0.5);
        }

        @keyframes modalAppear {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
};

export default EditBoxModal;